<template>
  <div class="content if-profile report-tab">
    <div class="md-layout financal-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
         <VRHeader :headerData="this.headerData"/>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="md-layout">
          <div class="md-layout-item p-0">
            <md-card class="if_card">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                  <md-card-header class="md-card-header-icon">Scores</md-card-header>
                </div>
              </div>
              <md-card-content>
                <div class="md-layout p-4">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card header-color="blue" class="text-card scores-list-star">
                      <template slot="header" header-color="rose">
                        <h4 class="title m-0">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                          >KPI Scores</div>
                        </h4>
                      </template>
                      <template slot="content">
                        <!-- <h4 class="Performance Scores">KPI Scores<br /></h4> -->
                        <div class="extra_space">
                          <p>
                            Tabulated results from these KPIs are integrated
                            into Vestimate value calculations. Detailed tables
                            and charts supporting these scores can be found in
                            sections IV and V.
                          </p>
                          <h5 class="table_header">Cash Flow:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Current Ratio:
                                {{
                                  this.vestimateScores['Current Ratio']['KPI']
                                    ? this.vestimateScores['Current Ratio'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Current Ratio'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Current Ratio'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Days Payable:
                                {{
                                  this.vestimateScores['Days Payable']['KPI']
                                    ? this.vestimateScores['Days Payable'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Days Payable'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Days Payable'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <h5 class="table_header">Profitability:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Owner Earnings:
                                {{
                                  this.vestimateScores['Owner Earnings']['KPI']
                                    ? this.vestimateScores['Owner Earnings'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Owner Earnings'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Owner Earnings'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Owner Earnings Growth:
                                {{
                                  this.vestimateScores['Owner Earnings Growth'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores[
                                    'Owner Earnings Growth'
                                    ]['KPI']
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores[
                                    'Owner Earnings Growth'
                                    ]['KPI'] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores[
                                      'Owner Earnings Growth'
                                      ]['KPI']
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Sales Growth:
                                {{
                                  this.vestimateScores['Sales Growth']['KPI']
                                    ? this.vestimateScores['Sales Growth'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Sales Growth'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Sales Growth'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Return on Assets:
                                {{
                                  this.vestimateScores['Return on Assets'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores['Return on Assets'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Return on Assets'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Return on Assets'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <h5 class="table_header">Efficiency:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Days Receivable:
                                {{
                                  this.vestimateScores['Days Receivable']['KPI']
                                    ? this.vestimateScores['Days Receivable'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Days Receivable'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Days Receivable'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Efficiency Index:
                                {{
                                  this.vestimateScores['Efficiency Index'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores['Efficiency Index'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Efficiency Index'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Efficiency Index'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <h5 class="table_header">Debt-Risk:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Modified Z-Score:
                                {{
                                  this.vestimateScores['Modified Z-Score'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores['Modified Z-Score'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Modified Z-Score'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Modified Z-Score'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Interest Coverage:
                                {{
                                  this.vestimateScores['Interest Coverage'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores['Interest Coverage'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Interest Coverage'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Interest Coverage'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Total Liabilities: Net Worth:
                                {{
                                  this.vestimateScores[
                                    'Total Liabilities to Net Worth'
                                  ]['KPI']
                                    ? this.vestimateScores[
                                    'Total Liabilities to Net Worth'
                                    ]['KPI']
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores[
                                    'Total Liabilities to Net Worth'
                                    ]['KPI'] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores[
                                      'Total Liabilities to Net Worth'
                                      ]['KPI']
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <h5 class="table_header">Market Opportunity:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Market Opportunity Index:
                                {{
                                  this.vestimateScores['Market Opportunity'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores[
                                    'Market Opportunity'
                                    ]['KPI']
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Market Opportunity'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores[
                                      'Market Opportunity'
                                      ]['KPI']
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Industry Market Growth:
                                {{
                                  this.vestimateScores[
                                    'Industry Market Growth'
                                  ]['KPI']
                                    ? this.vestimateScores[
                                    'Industry Market Growth'
                                    ]['KPI']
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores[
                                    'Industry Market Growth'
                                    ]['KPI'] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores[
                                      'Industry Market Growth'
                                      ]['KPI']
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- <md-list class="md-double-line md-dense">
                          <md-title class="color-blue ">Cash Flow:</md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Current Ratio: {{this.vestimateScores['Current Ratio']['KPI']?this.vestimateScores['Current Ratio']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Current Ratio']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Current Ratio']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Days Payable: {{this.vestimateScores['Days Payable']['KPI']?this.vestimateScores['Days Payable']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Days Payable']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Days Payable']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class="color-blue">
                            Profitability:
                          </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Owner Earnings: {{this.vestimateScores['Owner Earnings']['KPI']?this.vestimateScores['Owner Earnings']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Owner Earnings']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Owner Earnings']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Owner Earnings Growth: {{this.vestimateScores['Owner Earnings Growth']['KPI']?this.vestimateScores['Owner Earnings Growth']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Owner Earnings Growth']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Owner Earnings Growth']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Sales Growth: {{this.vestimateScores['Sales Growth']['KPI']?this.vestimateScores['Sales Growth']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Sales Growth']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Sales Growth']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Return on Assets: {{this.vestimateScores['Return on Assets']['KPI']?this.vestimateScores['Return on Assets']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Return on Assets']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Return on Assets']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class="color-blue ">Efficiency:  </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Days Receivable: {{this.vestimateScores['Days Receivable']['KPI']?this.vestimateScores['Days Receivable']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Days Receivable']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Days Receivable']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Efficiency Index: {{this.vestimateScores['Efficiency Index']['KPI']?this.vestimateScores['Efficiency Index']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Efficiency Index']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Efficiency Index']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class="color-blue">Debt-Risk: </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Modified Z-Score: {{this.vestimateScores['Modified Z-Score']['KPI']?this.vestimateScores['Modified Z-Score']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Modified Z-Score']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Modified Z-Score']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Interest Coverage: {{this.vestimateScores['Interest Coverage']['KPI']?this.vestimateScores['Interest Coverage']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Interest Coverage']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Interest Coverage']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Total Liabilities: Net Worth: {{this.vestimateScores['Total Liabilities to Net Worth']['KPI']?this.vestimateScores['Total Liabilities to Net Worth']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Total Liabilities to Net Worth']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Total Liabilities to Net Worth']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class="color-blue"
                            >Market Opportunity:</md-title
                          >
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">
                                Market Opportunity Index: {{this.vestimateScores['Market Opportunity']['KPI']?this.vestimateScores['Market Opportunity']['KPI']:""}}
                              </p>
                            </div>
                            <div v-if="this.vestimateScores['Market Opportunity']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Market Opportunity']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <span>Industry Market Growth: {{this.vestimateScores['Industry Market Growth']['KPI']?this.vestimateScores['Industry Market Growth']['KPI']:""}}</span>
                            </div>
                            <div v-if="this.vestimateScores['Industry Market Growth']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Industry Market Growth']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>-->
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card
                      header-color="blue"
                      class="text-card scores-list-star other-value"
                    >
                      <template slot="header" header-color="rose">
                        <h4 class="title m-0">
                          <div
                            class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                          >Other Value Indicators</div>
                        </h4>
                      </template>
                      <template slot="content">
                        <!-- <h4 class="Performance Scores">
                          Other Value Indicators<br />
                        </h4>-->
                        <div class="extra_space">
                          <ul>
                            <li>
                              Assess the age, loyalty, training, experience and
                              motivation of the workforce.
                            </li>
                          </ul>
                          <h5 class="table_header">Higher is better:</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Key Employees:
                                {{
                                  this.vestimateScores['Key Employees']['KPI']
                                    ? this.vestimateScores['Key Employees'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Key Employees'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Key Employees'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <ul>
                            <li>
                              Is customer stability seasonal with low repeat
                              sales or year round with high repeat levels?
                            </li>
                          </ul>
                          <h5 class="table_header">Higher is better: not seasonal/more repeat sales.</h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Customer Base:
                                {{
                                  this.vestimateScores['Customer Base']['KPI']
                                    ? this.vestimateScores['Customer Base'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Customer Base'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Customer Base'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <ul>
                            <li>Are technology practices up to date?</li>
                          </ul>
                          <h5 class="table_header">
                            How do they compare with competitors? Higher is
                            better.
                          </h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Technology Level:
                                {{
                                  this.vestimateScores['Technology Level'][
                                    'KPI'
                                  ]
                                    ? this.vestimateScores['Technology Level'][
                                    'KPI'
                                    ]
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores['Technology Level'][
                                    'KPI'
                                    ] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores['Technology Level'][
                                      'KPI'
                                      ]
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>

                          <ul>
                            <li>
                              Do the top 5 customers account for >25% of
                              revenue; or does any one
                            </li>
                          </ul>
                          <h5 class="table_header">
                            customer account for >10%? Higher (less
                            concentration) is better.
                          </h5>
                          <table class="table1" v-if="this.vestimateScores">
                            <tr>
                              <td>
                                Customer Concentration:
                                {{
                                  this.vestimateScores[
                                    'Customer Concentration'
                                  ]['KPI']
                                    ? this.vestimateScores[
                                    'Customer Concentration'
                                    ]['KPI']
                                    : ''
                                }}
                              </td>
                              <td>
                                <div
                                  v-if="
                                    this.vestimateScores[
                                    'Customer Concentration'
                                    ]['KPI'] === 'n/a'
                                  "
                                  class="md-button-content"
                                >
                                  <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                </div>
                                <div v-else class="md-button-content">
                                  <md-icon
                                    v-for="(v, i) in getStars(
                                      this.vestimateScores[
                                      'Customer Concentration'
                                      ]['KPI']
                                    )"
                                    :key="i"
                                  >{{ v }}</md-icon>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- <md-list class="md-double-line md-dense">
                          <md-title class=""
                            >Assess the age, loyalty, training, experience and
                            motivation of the workforce. <br />
                            Higher is better.
                          </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Key Employees: {{this.vestimateScores['Key Employees']['KPI']?this.vestimateScores['Key Employees']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Key Employees']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Key Employees']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class=""
                            >Is customer stability seasonal with low repeat
                            sales or year round with high repeat levels?<br />
                            Higher is better: not seasonal/more repeat sales.
                          </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Customer Base: {{this.vestimateScores['Customer Base']['KPI']?this.vestimateScores['Customer Base']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Customer Base']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Customer Base']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class=""
                            >Are technology practices up to date?<br />
                            How do they compare with competitors? Higher is
                            better.
                          </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">Technology Level: {{this.vestimateScores['Technology Level']['KPI']?this.vestimateScores['Technology Level']['KPI']:""}}</p>
                            </div>
                            <div v-if="this.vestimateScores['Technology Level']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Technology Level']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>
                        <md-list class="md-double-line md-dense">
                          <md-title class=""
                            >Do the top 5 customers account for >25% of revenue;
                            or does any one <br />
                            customer account for >10%? Higher (less
                            concentration) is better.
                          </md-title>
                          <md-list-item>
                            <div class="md-list-item-text">
                              <p class="md-subheading">
                                Customer Concentration: {{this.vestimateScores['Customer Concentration']['KPI']?this.vestimateScores['Customer Concentration']['KPI']:""}}
                              </p>
                            </div>
                            <div v-if="this.vestimateScores['Customer Concentration']['KPI'] === 'n/a'" class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(0)"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                            <div v-else class="md-button-content">
                              <md-icon  v-for="(v, i) in getStars(this.vestimateScores['Customer Concentration']['KPI'])"  :key="i">
                                {{ v }}
                              </md-icon>
                            </div>
                          </md-list-item>
                        </md-list>-->
                      </template>
                    </profile-card>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VRHeader from './_partials/VRHeader';
import { ProfileCard } from '@/components';
import { mapState } from 'vuex';
import ratingMixin from '@/mixins/rating-mixin';

export default {
  name: 'vr-scores',
  components: {
    ProfileCard,
    VRHeader,
  },
  mixins: [ratingMixin],
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      vestimateScores: (state) => state.user.vestimate_report.data.IF['scores'],
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      displayArea: (state) => state.user.vestimate_report.data.MR.area,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      companyName: (state) => state.user.vestimate_report.data.input_structure['Company Name']['value']
    }),
  },
  props: ['headerData'],
  mounted() { },
  methods: {},
};
</script>
<style lang="scss">
.scores-list-star {
  .md-list {
    .md-list-item-content {
      min-height: 45px !important;
      .md-button-content {
        .md-icon {
          color: #3b7ef1;
        }
      }
    }
  }
}

.scores-list-star.other-value {
  .md-list {
    border-bottom: 1px solid #ddd;
  }
}
</style>

.scores-list-star {
  .md-list {
    .md-list-item-content {
      min-height: 45px !important;
      .md-button-content {
        .md-icon {
          color: #3b7ef1;
        }
      }
    }
  }
}

.scores-list-star.other-value {
  .md-list {
    border-bottom: 1px solid #ddd;
  }
}
